<template>
  <b-card-code>
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label>Lead Source</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Lead Source"
              >
                <v-select
                  v-model="selectedLeadSource"
                  label="name"
                  placeholder="None"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="leadSourceOption"
                  @input="leadSource"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="4"
            v-if="selectedLeadSource && selectedLeadSource.name == 'Campaign'"
          >
            <b-form-group>
              <label>Select Campaign</label>
              <v-select
                v-model="campaign"
                label="name"
                placeholder="None"
                :options="$store.state.master.campaigns"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="display">
            <b-form-group>
              <label>Sub Source</label>
              <v-select
                placeholder="None"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="selectedSubSource"
                :label="setLabel"
                :options="subSourceOption"
              >
                <template #option="{ fullname, name, profile_image, username, color }">
                  <b-avatar
                    :src="getprofileImage(profile_image)"
                    v-if="
                      (selectedLeadSource &&
                        selectedLeadSource.name == 'Company Associate Partner') ||
                      selectedLeadSource.name == 'Employee' ||
                      selectedLeadSource.name == 'Franchise'
                    "
                  />
                  <span :class="'font-weight-bolder' + ' text-' + color">
                    {{ fullname || name }}
                  </span>

                  <span
                    :class="' text-' + color"
                    v-if="
                      (selectedLeadSource &&
                        selectedLeadSource.name == 'Company Associate Partner') ||
                      selectedLeadSource.name == 'Employee' ||
                      selectedLeadSource.name == 'Franchise'
                    "
                    >({{ username }})</span
                  >
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label>Client Name</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Name">
                <b-form-input v-model="name" placeholder="Enter Name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Client's Surname</label>
              <b-form-input v-model="surname" placeholder="Enter Surname" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Client's Father/Husband Name </label>
              <b-form-input v-model="fathername" placeholder="Enter Name" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Lead Date</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Lead Date"
              >
                <flat-pickr
                  v-model="leadDate"
                  class="form-control"
                  :state="errors.length > 0 ? false : null"
                  :config="{
                    enableTime: false,
                    dateFormat: 'd/m/Y',
                    defaultDate: new Date(),
                    maxDate: new Date(),
                  }"
                  style="background-color: transparent"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label>Next FollowUP Date</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Lead Date"
              >
                <b-form-datepicker
                  v-model="nextfollowupdate"
                  menu-class="w-100"
                  calendar-width="100%"
                  :date-format-options="{
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                  }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <!-- <b-col md="6">
            <b-form-group>
              <label>Contact Person</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Contact Person"
              >
                <b-form-input
                  v-model="contactPerson"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Contact Person"

                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <b-col md="4">
            <b-form-group>
              <label>Mobile</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" name="Mobile">
                <b-form-input
                  v-model="mobile"
                  maxlength="10"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Mobile"
                  @keydown="onlyDigits"
                  @paste="handlePaste"
                  @input="validateMobile"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Email</label>
              <b-form-input v-model="email" placeholder="Enter Email" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Lead Category</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Lead Category"
              >
                <v-select
                  v-model="leadcategory_id"
                  label="name"
                  placeholder="None"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="leadCategoryOptions"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Occupation</label>
              <!-- <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Occupation"
              > -->
              <b-form-input v-model="occupation" placeholder="Enter Occupation" />
              <!-- <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider> -->
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Comapany Name</label>
              <!-- <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Company Name"
              > -->
              <b-form-input v-model="lead_companyname" placeholder="Enter Company Name" />
              <!-- <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider> -->
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Job Title</label>
              <!-- <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Job Title"
              > -->
              <b-form-input v-model="lead_jobtitle" placeholder="Enter Job Title" />
              <!-- <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider> -->
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Lead Cost</label>
              <b-form-input v-model="lead_cost" type="number" min="0" step="0.01" placeholder="Enter Lead Cost" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Address</label>
              <b-form-input v-model="address" placeholder="Enter Address" />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label>Pin Code</label>
              <b-form-input
                v-model="pincode"
                maxlength="6"
                @input="clickPincode($event)"
                type="number"
                placeholder="Enter Pin Code"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>City</label>
              <v-select
                v-model="city"
                :options="cityOption"
                @input="clickArea($event)"
                label="City"
                placeholder="None"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Area</label>
              <v-select
                v-model="area"
                :options="areaOption"
                placeholder="None"
                @input="handlePincode()"
                label="PostOfficeName"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>State</label>
              <v-select
                v-model="state"
                placeholder="None"
                :options="stateOptions"
                label="State"
                @input="handleCity()"
              />
            </b-form-group>
          </b-col>

          <!-- <b-col md="4">
            <b-form-group>
              <label>Area</label>
                <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" name="Area">
                <b-form-input v-model="area" :state="errors.length > 0 ? false : null" placeholder="Enter Area"
                   />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>City</label>
                <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" name="City">
                <b-form-input v-model="city" :state="errors.length > 0 ? false : null" placeholder="Enter City"
                   />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Pin Code</label>
                <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" name="Pin Code" rules="digits:6">
                <b-form-input v-model="pincode" maxlength="6" :state="errors.length > 0 ? false : null" placeholder="Enter Pin Code"
                   />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>State</label>
                <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" re name="State">
                <b-form-input v-model="state" :state="errors.length > 0 ? false : null" placeholder="Enter State"
                   />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <b-col md="4">
            <b-form-group>
              <label>Priority</label>
              <validation-provider #default="{ errors }" name="Priority">
                <v-select
                  v-model="priority"
                  label="name"
                  placeholder="Select Priority"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="priorityOptions"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Remark</label>
              <validation-provider #default="{ errors }" name="Remark">
                <b-form-input
                  v-model="remark"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Remark"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="role != 'franchise'">
            <b-form-group>
              <label>Select Type</label>
              <v-select
                v-model="selectedType"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="assigntoTypeOptions"
                placeholder="None"
                @input="handleAssign()"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="selectedType !== 'Self'">
            <b-form-group>
              <label>Assign to</label>
              <v-select
                v-model="selectedAssignTo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="fullname"
                :options="assignToOption"
                placeholder="None"
              >
                <template #option="{ profile_image, username, color, fullname }">
                  <b-avatar
                    :src="getprofileImage(profile_image)"
                    v-if="
                      selectedType == 'Company Associate Partner' ||
                      selectedType == 'Employee' ||
                      selectedType == 'Franchise'
                    "
                  />
                  <span :class="'font-weight-bolder ' + 'text-' + color">
                    {{ fullname }}
                  </span>
                  <span
                    :class="'text-' + color"
                    v-if="
                      selectedType == 'Company Associate Partner' ||
                      selectedType == 'Employee' ||
                      selectedType == 'Franchise'
                    "
                    >({{ username }})</span
                  >
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Commission</label>
              <b-form-input v-model="commissionAmount" type="number" min="0" step="0.01" placeholder="Enter Commission Amount" />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="submitForm"
              :disabled="submitDisable"
              class="mr-4"
            >
              Submit
            </b-button>
            <b-button variant="primary" @click="onClickBack">Back </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <!-- Remarks History Section (for Edit mode) -->
    <b-row v-if="ifEdit && leadData.followUpData && leadData.followUpData.length > 0" class="mt-4">
      <b-col cols="12">
        <hr />
        <h5 class="mb-3" style="font-weight: 600; color: #7367f0;">
          <feather-icon icon="ClockIcon" size="20" class="mr-1" />
          Remarks History
        </h5>
      </b-col>
      <b-col cols="12">
        <app-timeline>
          <app-timeline-item
            v-for="(item, index) in leadData.followUpData"
            :key="index"
            :variant="
              item.priority == 'COLD'
                ? 'info'
                : item.priority == 'HOT'
                ? 'danger'
                : item.priority == 'WARM'
                ? 'success'
                : 'primary'
            "
          >
            <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
              <h5>
                <span style="font-weight: 600 !important">{{ getFollowupUserName(item) }}</span>
                done this Changes. And take Followup by
                <span style="font-weight: 900 !important">{{ item.followuptype }}</span>
              </h5>
              <p>{{ item.datetime ? item.datetime.split("-").reverse().join("/") : '' }}</p>
            </div>
            <p>Next Folloup After {{ item.nextfollowupafterdays }} days</p>
            <p>{{ item.remarks }}</p>
            <p>
              Project Name :-<span
                :style="
                  item.project_id ? 'color:green; font-weight: 600' : 'color: red'
                "
              >
                <span v-if="item.project_id == 0">Other </span>
                <span v-else>{{ item.project ? item.project.projectname : "NONE SELECTED" }}</span>
              </span>
            </p>
            <p>
              Status :-
              <b-badge
                v-if="item.status"
                variant="primary"
                class="badge-glow m-0"
              >
                {{ getStatusName(item.status) }}
              </b-badge>
              <span v-else style="color: red"> NONE SELECTED</span>
            </p>
          </app-timeline-item>
        </app-timeline>
      </b-col>
    </b-row>

    <!-- <template #code>
      {{ codeType }}
    </template> -->
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BAvatar,
  BBadge,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
  min_value,
} from "@validations";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Datepicker from "vuejs-datepicker";
import axios from "@/components/axios";
import moment from "moment";

export default {
  components: {
    PinchScrollZoom,
    flatPickr,
    Datepicker,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BAvatar,
    BBadge,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      selectedLeadSource: "",
      selectedSubSource: "",
      leadSourceOption: [],
      subSourceOption: [],
      leadValue: "",
      name: "",
      test: "",
      leadDate: moment(new Date()).format("DD/MM/yyyy"),
      // nextfollowupdate: moment(new Date()).format("DD/MM/yyyy"),
      mobile: "",
      email: "",
      address: "",
      area: "",
      state: "",
      stateOptions: [],
      city: "",
      cityOption: [],
      pincode: "",
      leadCategoryOptions: [],
      areaOption: [],
      priority: "",
      priorityOptions: [{ name: "HOT" }, { name: "WARM" }, { name: "COLD" }],
      remark: "",
      selectedAssignTo: "",
      assignToOption: [],
      fromState: "",
      ifEdit: false,
      submitDisable: false,
      selectedType: "",
      role: "",
      userId: "",
      allCp: "",
      cp: "",
      allFr: "",
      leadcategory_id: "",
      assigntoTypeOptions: ["Company Associate Partner", "Franchise", "Employee", "Self"],
      fr: "",
      userData: "",
      display: true,
      occupation: "",
      lead_companyname: "",
      lead_jobtitle: "",
      lead_cost: "",
      commissionAmount: "",
      type: "",
      otherLeadOption: [],
      cpleadsource: "",
      empleadsource: "",
      selfleadsource: "",
      mastercp: "",
      surname: "",
      fathername: "",
      campaign: "",
      leadData: {},
      leadStages: [],
    };
  },
  computed: {
    setLabel() {
      if (
        this.selectedLeadSource &&
        (this.selectedLeadSource.name == "Company Associate Partner" ||
          this.selectedLeadSource.name == "Franchise" ||
          this.selectedLeadSource.name == "Employee")
      ) {
        return "fullname";
      } else {
        return "name";
      }
    },
  },
  watch: {
    "$store.state.app.all_users": {
      handler: "leadSource",
      immediate: true,
    },
    mobile(newVal) {
      if (newVal) {
        // Remove any non-digit characters
        const cleaned = newVal.replace(/\D/g, '');
        // Limit to 10 digits
        if (cleaned !== newVal || cleaned.length > 10) {
          this.mobile = cleaned.substring(0, 10);
        }
      }
    },
  },
  mounted() {
    this.getLeadStages();
    const rights = JSON.parse(localStorage.getItem("UserRights"));
    const userDataFromStorage = JSON.parse(localStorage.getItem("userData"));
    const role = userDataFromStorage.role;
    this.userData = this.$store.state.app.user_data || userDataFromStorage;
    this.role = this.userData.role;
    this.userId = this.userData.id;
    this.type = this.userData.type;

    // Check if user has "visit manager" designation (check both store and localStorage)
    const userPosition = (this.userData.position && this.userData.position.name) ||
                         (userDataFromStorage.position && userDataFromStorage.position.name);
    const userType = this.userData.type || userDataFromStorage.type;
    const isVisitManager = (userPosition &&
      (userPosition === "Visit Manager" || userPosition === "visit manager")) ||
      userType === "visitmanager";

    if (role !== "admin" && !isVisitManager) {
      rights.map((item) => {
        if (item.modulename == "Lead") {
          if (this.$route.params.id) {
            if (item.edit !== 1) {
              this.$router.push("/crm/lead");
            }
          } else if (item.add !== 1) {
            this.$router.push("/crm/lead");
          }
        }
      });
      this.assigntoTypeOptions.splice(1, 1);
    }
    if (this.role == "franchise") {
      this.selectedAssignTo = this.userData;
      this.assignToOption = [this.userData];
    }
    this.init();
    this.ifEdit = !!this.$route.params.id;
    if (this.$route.query.mobile) {
      this.mobile = String(this.$route.query.mobile).replace(/\D/g, '').slice(-10);
    }
    this.ifEdit && this.getEditValue();
  },
  methods: {
    onlyDigits(event) {
      // Allow special keys: backspace, delete, tab, escape, enter
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];

      // Allow navigation keys
      const navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];

      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
        return;
      }

      // Allow special keys and navigation keys
      if (allowedKeys.includes(event.key) || navigationKeys.includes(event.key)) {
        return;
      }

      // Only allow digits (0-9)
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
        return false;
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData('text');
      const numbers = paste.replace(/\D/g, '');
      this.mobile = numbers;
    },
    validateMobile() {
      // Remove any non-digit characters (handles paste operations and other edge cases)
      this.mobile = this.mobile.replace(/\D/g, '');
    },
    getprofileImage(image) {
      if (image !== undefined && image !== null && image !== "") {
        let test = image.includes(this.imagePath) ? image : this.imagePath + image;
        return test;
      }
      return image;
    },
    async handleAssign() {
      this.assignToOption = [];
      if (this.selectedType == "Company Associate Partner") {
        // if (this.userData.role != "employee") {
          this.getAllCp();
        // } else {
        //   this.assignToOption = this.$store.state.app.all_users.filter(
        //     (item) => item.assignto == this.userData.id && item.role == "companyassociatepartner"
        //   );
        // }
      } else if (this.selectedType == "Franchise") {
        this.getAllFr();
      } else if (this.selectedType == "Self") {
        this.selectedAssignTo = this.userData;
      } else {
        if (this.userData.role != "companyassociatepartner") {
          this.getEmployee();
        } else {
          this.assignToOption = this.userData.assignto;
        }
      }

      if (!this.selectedType) {
        this.assignToOption = [];
      }
    },
    async getAllFr() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getFranchise`,
      };
      await axios(requestOptions)
        .then((response) => {
          if (
            this.selectedLeadSource &&
            this.selectedLeadSource.name == "Franchise" &&
            this.role == "admin"
          ) {
            this.subSourceOption = response.data.data;
          }
          if (this.selectedType == "Franchise" && this.role == "admin") {
            this.assignToOption = response.data.data;
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async getAllCp() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getallcp`,
      };
      await axios(requestOptions)
        .then((response) => {
          const list = Array.isArray(response.data?.data) ? response.data.data : [];
          if (
            this.selectedLeadSource &&
            this.selectedLeadSource.name == "Company Associate Partner"
          ) {
            this.subSourceOption = list;
          }
          if (this.selectedType == "Company Associate Partner") {
            this.assignToOption = list;
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async self() {
      this.assignToOption = [];
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/cpparentchild`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.selectedAssignTo = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async getCompanyAssociatePartner(id) {
      this.assignToOption = [];
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/cpparentchild`,
      };
      await axios(requestOptions)
        .then((response) => {
          if (this.role !== "admin") {
            this.assignToOption.push(response.data.data);
          }
          response.data.data.children.map((item) => {
            if (item.role == "companyassociatepartner") {
              this.assignToOption.push(item);
            }
          });
          if (this.role !== "admin" && response.data.data.parent) {
            this.assignToOption.push(response.data.data.parent);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async getTeam(id) {
      this.assignToOption = [];

      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getteam`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.assignToOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async handleCity() {
      this.areaOption = [];
      this.cityOption = [];
      this.fromState = true;
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getCityByState`,
        data: {
          State: this.state,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.cityOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    handlePincode() {
      if (this.fromState == true) {
        this.pincode = this.area?.Pincode;
      }
    },
    onClickBack() {
      this.$router.push("/crm/lead");
    },
    async leadSource() {
      this.campaign = "";

      if (this.selectedLeadSource) {
        this.leadValue = this.selectedLeadSource ? this.selectedLeadSource.name : "";
        if (this.leadValue == "Self") {
          this.display = false;
        } else {
          this.display = true;
        }
        this.subSourceOption = [];
        if (this.leadValue == "Company Associate Partner") {
          if (this.userData.role == "companyassociatepartner") {
            this.getCpDownline();
          } else {
            this.getAllCp();
          }
        } else if (this.leadValue == "Franchise") {
          this.getAllFr();
        } else if (this.leadValue == "Employee") {
          if (this.userData.role != "companyassociatepartner") {
            this.getEmployee();
          } else {
            this.subSourceOption = this.userData.assignto;
          }
        } else if (this.leadValue == "Self") {
          this.selectedSubSource = this.userData;
        } else if (this.leadValue == "Campaign") {
          this.$store.dispatch("master/getCampaigns");
        } else {
          this.subSourceOption = [];
          this.leadSourceOption.map((item) => {
            if (item.parent == this.selectedLeadSource.id) {
              this.subSourceOption.push(item);
            }
          });
        }
      }
    },

    handleCP(id) {
      this.allCp.map((item) => {
        if (item.parent == id) {
          this.cp.push(item);
          this.handleCP(item.id);
        }
      });
    },
    async getCpDownline(id) {
      await axios({
        method: "GET",
        url: `${this.baseApi}/getCompanyassociatepartner/${this.userData.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.cp = [];
          this.allCp = json.data.data;
          this.allCp = [this.userData];
          json.data.data.map((item) => {
            if (this.role != "admin" && this.type != "leadmanager") {
              item.color = "success";
            }
            this.allCp.push(item);
            if (item.children.length > 0) {
              this.handleChild(item.children, "info");
            }
          });

          if (this.selectedLeadSource.name == "Company Associate Partner") {
            this.subSourceOption = this.allCp;
          }
          if (this.selectedType == "Company Associate Partner") {
            this.assignToOption = this.allCp;
          }
          if (id !== undefined) {
            this.subSourceOption.map((item) => {
              if (item.id == id) {
                this.subsource = item;
              }
            });
          }
          if (this.role == "companyassociatepartner") {
            this.setCpAssignto();
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    setCpAssignto() {
      this.assignToOption = [...this.userData.assignto, ...this.assignToOption];
    },
    handleChild(childs, color) {
      childs.map((item) => {
        if (this.role == "admin" || this.type == "leadmanager") {
          item.color = color;
        }
        this.allCp.push(item);
        if (item.children.length > 0) {
          this.handleChild(
            item.children,
            color == "info" && this.role == "admin" ? "success" : ""
          );
        }
      });
    },

    handleFr(id) {
      this.allFr.map((item) => {
        if (item.parent == id) {
          this.fr.push(item);
          this.handleFr(item.id);
        }
      });
    },
    async getFrDownline(id) {
      await axios({
        method: "GET",
        url: `${this.baseApi}/getallfranchise`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.fr = [];
          this.allFr = json.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async getEmployee() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/getEmployee`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          if (this.selectedLeadSource.name == "Employee") {
            this.subSourceOption = json.data.data;
          }
          if (this.selectedType == "Employee") {
            this.assignToOption = json.data.data;
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async getEditValue() {
      // Use getleadById endpoint to get followup data as well
      await axios({
        method: "GET",
        url: `${this.baseApi}/getleadById/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then(async (json) => {
          const leadData = Array.isArray(json.data.data) ? json.data.data[0] : json.data.data;
          await this.getEditItems(leadData);
        })
        .catch((error) => console.log(error, "error"));
    },
    async getEditItems(item) {
      (this.selectedLeadSource =
        item.leadsource && item.leadsource.length > 0 ? item.leadsource[0] : ""),
        (this.selectedSubSource =
          item.subsource && item.subsource.length > 0 ? item.subsource[0] : ""),
        (this.name = item.name);

      // Handle leaddate - it might already be in DD/MM/YYYY format
      if (item.leaddate) {
        // Check if it's already in DD/MM/YYYY format
        if (item.leaddate.includes('/')) {
          this.leadDate = item.leaddate;
        } else {
          // Parse as YYYY-MM-DD format
          this.leadDate = moment(item.leaddate, "YYYY-MM-DD").format("DD/MM/yyyy");
        }
      } else {
        this.leadDate = moment(new Date()).format("DD/MM/yyyy");
      }

        (this.mobile = item.mobile),
        (this.email = item.email),
        (this.test = item.email),
        (this.address = item.address),
        (this.area = item.area),
        (this.state = item.state),
        (this.city = item.city),
        (this.pincode = item.pincode),
        (this.campaign = item.campaign),
        (this.priority = item.priority ? { name: item.priority } : ""),
        (this.remark = item.remarks),
        (this.surname = item.surname),
        (this.fathername = item.fathername);

      // Handle both old structure (assignto array/object) and new structure (assignedToUser/assigned_to_user object)
      // Check for both camelCase (assignedToUser) and snake_case (assigned_to_user) field names
      let assignedToUser = null;
      let assignedToUserId = null;

      // Try camelCase first (assignedToUser)
      if (item.assignedToUser && typeof item.assignedToUser === 'object') {
        assignedToUser = item.assignedToUser;
        assignedToUserId = assignedToUser.id || null;
        this.selectedAssignTo = item.assignedToUser;
      }
      // Try snake_case (assigned_to_user)
      else if (item.assigned_to_user && typeof item.assigned_to_user === 'object') {
        assignedToUser = item.assigned_to_user;
        assignedToUserId = assignedToUser.id || null;
        this.selectedAssignTo = item.assigned_to_user;
      }
      // Try assignto as object/array or ID
      else if (item.assignto !== undefined && item.assignto !== null && item.assignto !== '') {
        if (Array.isArray(item.assignto) && item.assignto.length > 0) {
          assignedToUser = item.assignto[0];
          assignedToUserId = assignedToUser.id || assignedToUser || null;
          this.selectedAssignTo = item.assignto[0];
        } else if (typeof item.assignto === 'object' && !Array.isArray(item.assignto) && Object.keys(item.assignto).length > 0) {
          assignedToUser = item.assignto;
          assignedToUserId = assignedToUser.id || null;
          this.selectedAssignTo = item.assignto;
        } else if (typeof item.assignto === 'number' || (typeof item.assignto === 'string' && !isNaN(item.assignto) && item.assignto !== '')) {
          // If assignto is just an ID (number or numeric string), store it for later lookup
          assignedToUserId = parseInt(item.assignto);
          this.selectedAssignTo = "";
        } else {
          this.selectedAssignTo = "";
        }
      } else {
        this.selectedAssignTo = "";
      }

      // Use API's select_type field directly if available (fixes incorrect "self" default)
      if (item.select_type) {
        // Map API values to dropdown options (API uses lowercase, dropdown uses title case)
        const typeMapping = {
          'employee': 'Employee',
          'self': 'Self',
          'companyassociatepartner': 'Company Associate Partner',
          'franchise': 'Franchise'
        };
        this.selectedType = typeMapping[item.select_type.toLowerCase()] || item.select_type;

        // If type is "Self", set assign to current user
        if (this.selectedType === "Self") {
          this.selectedAssignTo = this.userData;
          this.assignToOption = [this.userData];
        } else {
          // Load assign options based on the type, then match the assigned user
          await this.handleAssign();

          // After options are loaded, find and set the correct assigned user
          if (assignedToUserId) {
            // Try to find user in loaded options by ID
            const matchedUser = this.assignToOption.find(option => {
              const optionId = option.id || option;
              return optionId === assignedToUserId || optionId === parseInt(assignedToUserId);
            });

            if (matchedUser) {
              this.selectedAssignTo = matchedUser;
            } else if (assignedToUser) {
              // If exact match not found but we have the user object, use it
              this.selectedAssignTo = assignedToUser;
              // Also add it to options if not already there
              const existsInOptions = this.assignToOption.find(opt => {
                const optId = opt.id || opt;
                return optId === assignedToUserId || optId === parseInt(assignedToUserId);
              });
              if (!existsInOptions) {
                this.assignToOption.push(assignedToUser);
              }
            } else if (assignedToUserId) {
              // If we only have an ID, try to find it in all_users from store
              const allUsers = this.$store.state.app.all_users || [];
              const foundUser = allUsers.find(user => {
                const userId = user.id || user;
                return userId === assignedToUserId || userId === parseInt(assignedToUserId);
              });
              if (foundUser) {
                this.selectedAssignTo = foundUser;
                // Add to options if not already there
                const existsInOptions = this.assignToOption.find(opt => {
                  const optId = opt.id || opt;
                  return optId === assignedToUserId || optId === parseInt(assignedToUserId);
                });
                if (!existsInOptions) {
                  this.assignToOption.push(foundUser);
                }
              }
            }
          } else if (assignedToUser) {
            // If we have user object but no ID, use it directly
            this.selectedAssignTo = assignedToUser;
            // Add to options if not already there
            const existsInOptions = this.assignToOption.find(opt => {
              const optId = opt.id || opt;
              const userId = assignedToUser.id || assignedToUser;
              return optId === userId || optId === parseInt(userId);
            });
            if (!existsInOptions) {
              this.assignToOption.push(assignedToUser);
            }
          }
        }
      } else {
        // Fallback to inference logic only if select_type is not provided
        this.getCustomerUser(this.selectedAssignTo);
      }
      this.lead_companyname = item.lead_companyname;
      this.lead_jobtitle = item.lead_jobtitle;
      this.lead_cost = item.lead_cost;
      this.commissionAmount = item.commission;
      this.occupation = item.occupation;
      this.leadcategory_id = item.leadcategory.length > 0 ? item.leadcategory[0] : "";

      // Store the full lead data for remarks history
      this.leadData = item;

      // Sort followup data by date (most recent first)
      if (this.leadData.followUpData && this.leadData.followUpData.length > 0) {
        this.leadData.followUpData.sort((a, b) => {
          return new Date(b.datetime) - new Date(a.datetime);
        });
      }

      this.handleCity();
      this.handleArea();
      this.handleAssign();

      // this.clickPincode()
    },
    async getLeadStages() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/leadstage`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((response) => {
          this.leadStages = response.data.data.data || response.data.data || [];
        })
        .catch((error) => console.log(error, "error"));
    },
    getStatusName(status) {
      if (!status) return 'NONE SELECTED';

      // If status is already an object with name, return it
      if (typeof status === 'object' && status.name) {
        return status.name;
      }

      // Convert status to number for comparison (status could be string or number)
      const statusId = typeof status === 'object' ? status.id : parseInt(status);
      const stage = this.leadStages.find(s => s.id === statusId);
      return stage ? stage.name : status;
    },
    getFollowupUserName(followup) {
      // enterby is a user ID number, find the user from the users list
      const allUsers = this.$store.state.app.all_users || [];

      if (followup.enterby && typeof followup.enterby === 'number') {
        const user = allUsers.find(u => u.id === followup.enterby);
        if (user) {
          return user.fullname || user.name || 'User #' + followup.enterby;
        }
      }

      // Check other possible fields for user data
      if (followup.enterby_data && followup.enterby_data.length > 0) {
        return followup.enterby_data[0].name || followup.enterby_data[0].fullname || 'Unknown';
      }
      if (followup.enterby && typeof followup.enterby === 'object') {
        return followup.enterby.name || followup.enterby.fullname || 'Unknown';
      }
      if (followup.enterby && typeof followup.enterby === 'string') {
        return followup.enterby;
      }
      if (followup.user) {
        return followup.user.name || followup.user.fullname || 'Unknown';
      }
      return 'System';
    },
    async handleSubsource(id) {
      const requestoption = {
        method: "GET",
        url: `${this.baseApi}/getusersbyid/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      };
      await axios(requestoption).then((response) => {
        this.selectedSubSource = response.data.data[0];
      });
    },
    async getCustomerUser(assignto) {
      // First check if assigned user name matches logged-in user name
      // If they match, type should be "Self"
      if (assignto && this.userData) {
        const assignedUserName = (assignto.fullname || assignto.name || '').toLowerCase().trim();
        const loginUserName = (this.userData.fullname || this.userData.name || '').toLowerCase().trim();

        if (assignedUserName && loginUserName && assignedUserName === loginUserName) {
          this.selectedType = "Self";
          this.selectedAssignTo = this.userData;
          this.assignToOption = [this.userData];
          return;
        }
      }

      // If names don't match, derive type from role
      if (assignto && assignto.role == "companyassociatepartner") {
        this.selectedType = "Company Associate Partner";
        if (this.userData.role == "companyassociatepartner") {
          this.getCpDownline();
        } else {
          this.getAllCp();
        }
      } else if (assignto && assignto.role == "franchise") {
        this.selectedType = "Franchise";
        this.getFrDownline();
      } else if (assignto && assignto.role == "employee") {
        this.selectedType = "Employee";
        if (this.userData.role != "companyassociatepartner") {
          this.getEmployee();
        } else {
          this.assignToOption = this.userData.assignto;
        }
      } else {
        this.selectedType = "Self";
      }
    },
    async handleArea() {
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getAreaByCity`,
        data: {
          City: this.city,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.areaOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    clickArea(e) {
      if (this.fromState == true) {
        this.handleArea();
      }
    },
    async clickPincode() {
      this.area = "";
      this.city = "";
      this.state = "";
      const regex = new RegExp(/^[0-9]{6}$/);
      if (regex.test(this.pincode)) {
        this.fromState = false;
        const reportauthority = {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/pincode`,
          data: {
            Pincode: `${this.pincode}`,
          },
        };
        await axios(reportauthority)
          .then((response) => {
            this.cityOption = [];
            this.StateData = response.data.data;
            this.areaOption = response.data.data;
            this.state = response.data.data[0];
            const resArr = [];
            response.data.data.filter(function (item) {
              const i = resArr.findIndex((x) => x.City == item.City);
              if (i <= -1) {
                resArr.push(item);
              }
              return null;
            });
            this.cityOption = resArr;
          })
          .catch((error) => console.log(error, "error"));
      }
    },
    reset() {},
    submitForm(e) {
      const data = {
        leaddate: this.leadDate,
        branch: 1,
        company: 1,
        active: 1,
        leadsource: this.selectedLeadSource.id ?? "",
        subsource: this.selectedSubSource ? this.selectedSubSource.id : "",
        name: this.name,
        mobile: this.mobile,
        email: this.email,
        address: this.address,
        area: this.area?.PostOfficeName,
        state: this.state?.State,
        city: this.city?.City,
        pincode: this.pincode,
        campaign: this.campaign?.id,
        priority: this.priority?.name || "",
        remarks: this.remark,
        assignto: this.selectedAssignTo ? this.selectedAssignTo.id : "",
        lead_companyname: this.lead_companyname,
        lead_jobtitle: this.lead_jobtitle,
        lead_cost: this.lead_cost,
        commission: this.commissionAmount,
        occupation: this.occupation,
        surname: this.surname,
        fathername: this.fathername,

        leadcategory_id: this.leadcategory_id.id ?? "",
      };
      if (this.email == this.test) {
        delete data.email;
      }

      // var ifEdit = this.$route.params.id ? true : false;
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success == false) {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Plese Fill the All Field",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
        if (success) {
          this.submitDisable = true;
          const accessToken = localStorage.getItem("accessToken");
          const baseApi = process.env.VUE_APP_APIENDPOINT;
          await axios({
            method: `${this.ifEdit ? "put" : "post"}`,
            url: this.ifEdit
              ? `${baseApi}/lead/${this.$route.params.id}`
              : `${baseApi}/lead`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            data: JSON.stringify(data),
          })
            .then((json) => {
              this.submitDisable = false;

              this.$swal({
                title: "Submited",
                text: this.ifEdit ? "Lead Add SuccessFully" : "Lead Update SuccessFully",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              this.$router.push("/crm/lead");
            })
            .catch((error) => {
              this.submitDisable = false;

              let errorMessage = "";
              const isConflictError = error.response && (error.response.status === 409 || error.response.status === 404);
              const isValidationError = error.response && error.response.status === 422;

              if (isConflictError) {
                // Handle duplicate assignment error (409 Conflict)
                const responseData = error.response.data;

                // Try different possible message locations
                if (typeof responseData.message === 'string') {
                  errorMessage = responseData.message;
                } else if (responseData.message && typeof responseData.message === 'object') {
                  // Handle nested validation error structure
                  if (responseData.message.original) {
                    // Extract specific validation errors
                    const original = responseData.message.original;
                    let errors = [];

                    if (original.email && Array.isArray(original.email)) {
                      errors.push(`Email: ${original.email[0]}`);
                    }
                    if (original.name && Array.isArray(original.name)) {
                      errors.push(`Name: ${original.name[0]}`);
                    }
                    if (original.mobile && Array.isArray(original.mobile)) {
                      errors.push(`Mobile: ${original.mobile[0]}`);
                    }

                    errorMessage = errors.length > 0 ? errors.join(', ') : "Validation error occurred.";
                  } else {
                    // If message is an object but not the expected structure
                    errorMessage = "This lead is already assigned to another user.";
                  }
                } else if (responseData.error) {
                  errorMessage = responseData.error;
                } else {
                  errorMessage = "This lead is already assigned to another user.";
                }
              } else if (isValidationError) {
                // Handle validation errors (422 Unprocessable Entity)
                const validationErrors = error.response.data.message;
                if (validationErrors && validationErrors.original) {
                  let email = validationErrors.original.email
                    ? validationErrors.original.email[0]
                    : "";
                  let name = validationErrors.original.name
                    ? validationErrors.original.name[0]
                    : "";
                  errorMessage = email + " " + name;
                } else {
                  errorMessage = typeof validationErrors === 'string' ? validationErrors : "Validation error occurred.";
                }
              } else {
                // Handle other errors
                errorMessage = error.response?.data?.message || error.message || "An error occurred while creating the lead.";
              }

              this.$swal({
                title: isConflictError ? "Duplicate Assignment" : "Error!",
                text: errorMessage,
                icon: isConflictError ? "warning" : "error",
                timer: isConflictError ? 7000 : 5000, // Longer timer for duplicate assignment message
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    async init() {
      this.getLeadCategory();
      this.getLeadSource();
      // this.getAssignSource();
      this.getState();
    },
    async getLeadCategory() {
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/all-leadcategory`,
      };
      await axios(reportauthority)
        .then((response) => {
          this.leadCategoryOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async getState() {
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getState`,
      };
      await axios(reportauthority)
        .then((response) => {
          this.stateOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async getLeadSource(id, subid) {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/leadsourcedata`,
      };
      await axios(requestOptions)
        .then((response) => {
          // this.leadSourceOption = response.data.data;
          this.leadSourceOption = response.data.data.filter((item) => {
            if (
              this.userData.role == "companyassociatepartner" &&
              item.name != "Company Associate Partner" &&
              item.name != "Self"
            ) {
              return false;
            }

            if (
              this.userData.role == "franchise" &&
              item.name != "Franchise" &&
              item.name != "Self"
            ) {
              return false;
            }

            if (this.userData.role == "employee" && item.name == "Franchise") {
              return false;
            }
            return true;
          });
        })
        .catch((error) => console.log(error, "error"));
    },
    async getSubSource(id) {
      this.leadSourceOption.map((item) => {
        if (item.id == id) {
          this.selectedSubSource = item;
        }
      });
    },
    assigntest(data) {
      data.map((item) => {
        this.assignToOption.push(item);
        if (item.children && JSON.stringify(item.children) !== "[]") {
          this.assigntest1(item.children);
        }
      });
    },
    assigntest1(data) {
      data.map((item) => {
        this.assignToOption.push(item);
        if (item.children && JSON.stringify(item.children) !== "[]") {
          this.assigntest(item.children);
        }
      });
    },
  },
};
</script>
